// Caution: This is inspired from `autocomplete_select_hook`

import debounce from "lodash.debounce"
import { blur, addScopedEventListener } from "../helpers"
const debounceBy = 200

export const ServerAutocomplete = {
  active: false,
  mounted() {
    const textInput = this.textInput()
    const dropdownArrow = this.el.querySelector("svg")
    if (dropdownArrow)
      dropdownArrow.addEventListener("click", (event) => textInput.focus())

    textInput.addEventListener("focusin", (event) => this.toggleActive(true))
    textInput.addEventListener("focusout", () => this.toggleActive(false))
    textInput.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        e.stopImmediatePropagation()
        this.toggleActive(false)
      }
    })
    // Using mousedown so it occurs before the `focusout` event
    addScopedEventListener(this.el, "mousedown", "li", (e, choice) => {
      this.select(choice)
      e.preventDefault()
    })

    this.debouncedLoadOptions = debounce(() => {
      // In case it was hidden with escape:
      this.toggleActive(true)
      this.pushEventTo(this.el, "server-autocomplete:load-options", {
        value: textInput.value,
      })
    }, debounceBy)

    textInput.addEventListener("input", this.debouncedLoadOptions)

    const preselectValue = this.el.dataset.preselectValue
    const fieldValue = this.el.dataset.fieldValue

    if (preselectValue && !fieldValue) {
      const item = Array.from(this.el.querySelectorAll("li[data-value]")).find(
        (li) => li.dataset.value === preselectValue,
      )

      if (item) {
        this.select(item)
      }
    }
  },
  destroyed() {
    // Otherwise pushEventTo may be sent to the LiveView
    // See https://github.com/phoenixframework/phoenix_live_view/issues/4066
    this.debouncedLoadOptions.cancel()
  },
  updated() {
    if (this.active) {
      this.toggleActive(this.active)
    }
  },
  toggleActive(active) {
    this.active = active
    this.el.querySelector(".select").classList.toggle("select-active", active)
  },
  select(li) {
    // Store associated choice information in the hidden input, if any
    const hiddenValue = this.el.querySelector('input[type="hidden"]')
    // Can't select items with no `data-value` attribute
    if (!("value" in li.dataset)) return
    hiddenValue.value = li.dataset.value

    const textInput = this.textInput()
    textInput.value = li.innerText
    textInput.dispatchEvent(new Event("change", { bubbles: true }))
    blur()
  },
  textInput() {
    return this.el.querySelector('input[type="text"]')
  },
}
